import {useEffect} from 'react';
import {useDispatch} from 'react-redux';

import amplitudeAutodeliveryTracking from '@/services/analytics/amplitude/amplitudeAutoDeliveryDcxTracking';
import googleAnalyticsService from '@/services/analytics/ga/googleAnalyticsService';
import appContent from '@/services/content/appContent.typed';
import {hideAutoDeliveryStatusNoneDetailsPopup} from '@/state/slices/modalSlice';

import AutoDeliveryDcxDetailsStatusNoneTemplate from './components/AutoDeliveryDcxDetailsStatusNoneTemplate';

const AutoDeliveryDcxStatusNoneDetailsPopup = () => {
    const dispatch = useDispatch();
    const content = appContent.getAutoDeliveryContent()?.userOnboardContent;

    const amplitudeEvent = () => {
        amplitudeAutodeliveryTracking.trackAutoDeliveryDcxGetStartedButtonClick();
        googleAnalyticsService.trackAutoDeliveryGetStartedButtonClick();
    };

    useEffect(() => {
        amplitudeAutodeliveryTracking.trackAutoDeliveryDcxGetStartedScreen();
        googleAnalyticsService.trackAutoDeliveryGetStartedScreen();
    }, []);

    const onClose = () => dispatch(hideAutoDeliveryStatusNoneDetailsPopup());

    return (
        <AutoDeliveryDcxDetailsStatusNoneTemplate content={content} amplitudeEvent={amplitudeEvent} onClose={onClose} />
    );
};

export default AutoDeliveryDcxStatusNoneDetailsPopup;
